<template>
  <div class="flex flex-column gap-2">
    <span class="text-500 text-sm">
      Choose how snippets from different shows are ordered in the final
      playlist.
    </span>
    <div class="flex gap-3">
      <div
        class="display-order-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'display-order-option-active': modelValue.shuffle }"
        @click="$emit('update:modelValue', { ...modelValue, shuffle: true })"
      >
        <RadioButton
          inputId="displayOrderShuffle"
          :modelValue="modelValue.shuffle"
          :value="true"
          name="displayOrder"
          @update:modelValue="
            $emit('update:modelValue', { ...modelValue, shuffle: true })
          "
        />
        <label for="displayOrderShuffle" class="cursor-pointer">Shuffle</label>
      </div>
      <div
        class="display-order-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'display-order-option-active': !modelValue.shuffle }"
        @click="$emit('update:modelValue', { ...modelValue, shuffle: false })"
      >
        <RadioButton
          inputId="displayOrderOff"
          :modelValue="modelValue.shuffle"
          :value="false"
          name="displayOrder"
          @update:modelValue="
            $emit('update:modelValue', { ...modelValue, shuffle: false })
          "
        />
        <label for="displayOrderOff" class="cursor-pointer">Shuffle off</label>
      </div>
    </div>

    <Message severity="info" :closable="false">{{
      modelValue.shuffle
        ? "All selected shows' snippets are combined into one pool and shuffled together."
        : "Snippets are grouped by show, in the order you arrange below."
    }}</Message>
  </div>
</template>

<script setup>
import RadioButton from "primevue/radiobutton";
import Message from "primevue/message";

defineProps({
  modelValue: {
    type: Object,
    default: () => ({ shuffle: false }),
  },
});
defineEmits(["update:modelValue"]);
</script>

<style scoped>
.display-order-option {
  border: 1px solid var(--surface-border);
  transition: all 0.15s ease;
}

.display-order-option:hover {
  border-color: var(--primary-color);
}

.display-order-option-active {
  border-color: var(--primary-color);
  background: rgba(99, 102, 241, 0.08);
}
</style>
